export default "__VITE_ASSET__B2tnOwBJ__"